module.exports = __webpack_public_path__ + "fonts/DINPro-BoldItalic.5c42c7ea.otf";